import React from 'react';

import { LocationColumnType } from 'pages/Locations';
import { Column, ColumnType } from './Column';

export type TrelloViewDataType = {
    columns: ColumnType[] | LocationColumnType[];
};

export const TrelloView = ({
    initialData,
    selectedItemIds,
    setSelectedItemIds,
    columnWidth,
    padding = '15px',
}: {
    initialData: TrelloViewDataType;
    selectedItemIds?: string[];
    setSelectedItemIds?: (value: React.SetStateAction<string[]>) => void;
    columnWidth?: string;
    padding?: string;
}) => {
    return (
        <div className="inline-flex h-full gap-3" style={{ padding }}>
            {initialData.columns.map((column, index) => (
                <Column
                    key={index}
                    column={column}
                    selectedItemIds={selectedItemIds}
                    setSelectedItemIds={setSelectedItemIds}
                    columnWidth={columnWidth}
                />
            ))}
        </div>
    );
};
